var idealTextColor = require('idealTextColor'),
modal = require('modal');

var clubColours = (function() {
  const $primarySelector = $('#primary-display');
  const $primaryInput = $('#primary-colours');
  const $secondarySelector = $('#secondary-display');
  const $secondaryInput = $('#secondary-colours');

  var showColourSelect = function($selector, $input, text) {
    $(document).delegate(".color-grid .colour-item", "click", function(e) {
      $(this).addClass('selected');
      $('.btn-confirm').click();
    });

    $selector.on("click", function() {
      return $('window').modal({
        title: 'Select your clubs ' + text + ' colour',
        buildColours: true,
        complete: function() {
          updateValues($selector, $input);
        }
      });
    });
  };


  var updateValues = function($selector, $input) {
    var selectedColor = $('.color-grid .selected').attr('data-color'),
    textColour = $('window').idealTextColor(selectedColor);

    $selector.css('background-color', selectedColor);
    $selector.css('color', textColour);
    $input.val(selectedColor);
  };


  var init = function() {
    showColourSelect($primarySelector, $primaryInput, 'Primary');
    showColourSelect($secondarySelector, $secondaryInput, 'Secondary');
  };

  return {
    init: init
  };
})();

if($('.colour-select').length) {
  clubColours.init();
}



// WEBPACK FOOTER //
// ./library/js/modules/club-colours.js